
/**
 * 스트리밍 상태
 */
export type GetStreamingInfo200Status = typeof GetStreamingInfo200Status[keyof typeof GetStreamingInfo200Status];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStreamingInfo200Status = {
  ready: 'ready',
  processing: 'processing',
  error: 'error',
} as const;
